import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { maskCurrency, maskUnd } from '../../../../utils/mask';

import { TableSecProps } from './props';

import { TableStyle } from './styles';

import ModalAtendimentoEntrada from '../Modal';
import iconcoleta from '../../../../assets/img/coleta.svg';
import iconentrega from '../../../../assets/img/entrega.svg';
import { MovimentacoesServices } from '../../services/movimentacoesService';
import { ColumnType } from 'antd/lib/table';
import { Sorter } from '../../../../utils/sorte';
import TableSort from '../../../../components/TableSort';
import moment from 'moment';

const TableSec: React.FC<TableSecProps> = ({ nuNota }) => {
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const [response, setResponse] = useState();
  const [control, setControl] = useState(false);
  const [controller, setController] = useState(false);

  useEffect(() => {
    if (controller === false) {
      setControl(true);
      MovimentacoesServices.getNotasSecundarias(nuNota, cddAtivo?.codCdd).then((res) => {
        setResponse(res?.data.notas);
        if (res?.data.notas) setControl(false);
      });
      setController(true);
    }
  }, [controller, control, nuNota, cddAtivo?.codCdd]);

  const columns: ColumnType<any>[] = [
    {
      title: '',
      dataIndex: 'tipoMovimentacao',
      key: 'tipoMovimentacao',
      align: 'right',
      render: (text: any) => {
        const data =
          text === 'S' ? (
            <img width="10px" src={iconentrega} alt="Saída" title="Saída" />
          ) : (
            <img width="10px" src={iconcoleta} alt="Entrada" title="Entrada" />
          );
        return (
          <>
            <span>{data}</span>
          </>
        );
      },
    },
    {
      title: 'N° atendimento',
      dataIndex: 'nuNota',
      key: 'nuNota',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 1,
      },
    },
    {
      title: 'Nota',
      dataIndex: 'numNota',
      key: 'numNota',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 2,
      },
      render: (text: any, record: any) => {
        return <>{<ModalAtendimentoEntrada text={text} nuNota={record?.nuNota} />}</>;
      },
    },
    {
      title: 'Data lançamento',
      dataIndex: 'dtLancamento',
      key: 'dtLancamento',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 3,
      },
      render: (text: Date) => {
        return moment(text).format('LL');
      },
    },

    {
      title: 'Emitente',
      dataIndex: 'emitente',
      key: 'emitente',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 4,
      },
    },
    {
      title: 'Movimentação',
      dataIndex: 'movimentacao',
      key: 'movimentacao',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 5,
      },
    },
    {
      title: 'Peso bruto',
      dataIndex: 'pesoBruto',
      key: 'pesoBruto',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 6,
      },
      render: (text: number) => {
        return maskUnd(text) + ' KG';
      },
    },
    {
      title: 'Valor da mercadoria',
      dataIndex: 'vlrMercadoria',
      key: 'vlrMercadoria',
      align: 'center',
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 7,
      },
      render: (text: number = 0) => {
        return maskCurrency(text);
      },
    },
    {
      title: 'Chave da nota',
      dataIndex: 'chaveNfe',
      key: 'chaveNfe',
      align: 'center',
      sorter: {
        compare: Sorter.STRING,
        multiple: 8,
      },
    },
  ];

  return (
    <TableStyle>
      <TableSort
        columns={columns}
        size={'middle'}
        rowKey="numNota"
        style={{ border: '1px solid' }}
        loading={control === true ? true : false}
        dataSource={response}
        pagination={false}
      />
    </TableStyle>
  );
};

export default TableSec;
